import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const SupportedLocationsIcon = ({ isSelected = false, ...props }) => (
  <SvgIcon {...props} viewBox="0 0 12 16" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0C2.686 0 0 2.686 0 6C0 10.714 6 16 6 16C6 16 12 10.714 12 6C12 2.686 9.314 0 6 0ZM6 8.5C4.619 8.5 3.5 7.381 3.5 6C3.5 4.619 4.619 3.5 6 3.5C7.381 3.5 8.5 4.619 8.5 6C8.5 7.381 7.381 8.5 6 8.5Z"
      fill={isSelected ? "#4D44D8" : "#989898"}
    />
  </SvgIcon>
);

export default SupportedLocationsIcon;
